// TEMPORARY compatibility file — localStorage cart stub.

const CART_KEY = 'iwinto_temp_cart';

function readCart() {
  try {
    const raw = localStorage.getItem(CART_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeCart(items) {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
  } catch {
    // ignore
  }
}

export function addToCart(product) {
  // TODO: restore real cart logic
  if (!product?.id) return readCart();
  const cart = readCart();
  const idx = cart.findIndex((i) => i.id === product.id);
  if (idx >= 0) {
    cart[idx].quantity = (cart[idx].quantity || 1) + 1;
  } else {
    cart.push({ ...product, quantity: 1 });
  }
  writeCart(cart);
  return cart;
}

export function updateCartItemQuantity(productId, change) {
  // TODO: restore real cart logic
  const cart = readCart();
  const idx = cart.findIndex((i) => i.id === productId);
  if (idx < 0) return cart;
  const next = (cart[idx].quantity || 1) + Number(change || 0);
  if (next <= 0) cart.splice(idx, 1);
  else cart[idx].quantity = next;
  writeCart(cart);
  return cart;
}

export function getCartItemQuantity(productId) {
  const item = readCart().find((i) => i.id === productId);
  return item?.quantity || 0;
}

export function getCartItemCount() {
  return readCart().reduce((sum, i) => sum + (i.quantity || 0), 0);
}

export function getCart() {
  return readCart();
}

export function clearCart() {
  writeCart([]);
}
